import { Component, OnInit, ViewEncapsulation, OnDestroy, HostListener, ViewChild, ElementRef, Input } from '@angular/core';
import {
  FormGroup,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { AppStateService } from "../../../core-module/services/app-state.service";
import { NgbNavChangeEvent } from "@ng-bootstrap/ng-bootstrap";
import { Subject, takeUntil } from 'rxjs';

import { restore } from "../../../../assets/json/restoreTooltip.en";
import { CloStateService } from "../../../core-module/services/state/clo-state.service";
import { FeatureDefaultsStateService } from "../../../core-module/services/state/feature-defaults-state.service";
import { GraphStateService } from "../../../core-module/services/state/graph-state.service";
import { MiscFeatureStateService } from "../../../core-module/services/state/misc-feature-state.service";

// DO NOT re-add `changeDetection: ChangeDetectionStrategy.OnPush` to this component.
// CloLiteComponent mutates state (enableChecked, disableGraph, dataToShow,
// showCloLite, defaultColor, disableNumericClear, ...) from multiple `.subscribe()`
// callbacks (getCloLiteDefaultValue, getCloLiteHead, getChangedGraphData) and
// from the (change) handler `enableGraph()` without markForCheck. Under OnPush
// the "Enable feature" checkbox click did not make the graph/input fields
// editable on the first click (the .disable-graph CSS class stayed applied
// because the CD tick did not pick up the cascading subscription updates).
// See angular-21-upgrade.md memory for the same recurring trap on
// ConfigureDeviceModalComponent (4th occurrence).
@Component({
  standalone: false,
  selector: 'app-clo-lite',
  templateUrl: './clo-lite.component.html',
  styleUrls: ['./clo-lite.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CloLiteComponent implements OnInit, OnDestroy {
  addForm: FormGroup;
  rowLength = 0;
  registerForm: FormGroup;
  submitted = false;
  activeIdString: LegacyAny = "1";
  fewFieldValuePresent = false;

  dataToShow = [];
  unsubscribe = new Subject<void>();
  isTableValuesChanged = false;
  tableValueSubmit = false;
  isNumericCreatedRows = false;
  isGraphUpdated = false;
  disableGraph = false;
  defaultColor = true;
  disableAddBtn = false;
  unsubscribeNumeric = new Subject<void>();
  menuState;
  menuPosition;
  disableAddAboveBtn = false;
  disableAddBelowBtn = false;
  disableNumericClear = true;
  unsubscribeGraphType = new Subject<void>();
  enableChecked = false;
  showCloLite;
  subscription;
  restoreText = restore;

  @ViewChild("contextMenu", { static: false }) contextMenu: ElementRef;

  graphRepresentationType = "";
  afterClearField = false;
  fileResponse: LegacyAny = {};
  cloLIteDetail: LegacyAny;
  cloLiteEnable: boolean = false;
  @Input() public cloLiteSchema;
  cloLiteCreatFile: boolean = false;
  constructor(
    
    private fb: FormBuilder,
    private appState: AppStateService,
    private featureDefaults: FeatureDefaultsStateService,
    private graphState: GraphStateService,
    private clo: CloStateService,
    private misc: MiscFeatureStateService
  ) {
    this.addForm = this.fb.group({});
  }

  ngOnInit() {
    this.initForm();
    this.appState.setCloPointsStepValue("0");
    this.featureDefaults.getCloLiteDefaultValue.subscribe((response) => {
      if (response == "valid") {
        this.disableGraph = false;
        this.resetValues();
      }
    });

    const unSelectedFeat = this.appState.getUnSelectedFeatConfig();
    let isConfigEdited = false;
    let featIndex: number = 0;
    if (unSelectedFeat != null && unSelectedFeat.length > 0) {
      unSelectedFeat.forEach((element) => {
        if (
          element["featureName"].toString().toUpperCase() === "CLOLITE"
        ) {
          this.fileResponse = {};
          const CLOUnSelected: LegacyAny = element["featureParameters"][0];
          const clonewEditedData = {
            resp: {
              CLOLite: CLOUnSelected,
            },
          };
          isConfigEdited=true;
          this.fileResponse = clonewEditedData;
          unSelectedFeat.splice(featIndex, 1);
          this.appState.setUnSelectedFeatConfig(unSelectedFeat);
        } else {
          featIndex++;
        }
      });
    }

    if (!isConfigEdited) {
      // Use centralized method to get feature data
      // This automatically prioritizes SaveSetData over ConfigurationData
      const cloLiteData = this.appState.getFeatureData('CLOLite');
      if (cloLiteData) {
        this.fileResponse = { resp: { CLOLite: cloLiteData } };
      }
    }

    this.loadCloLIteDetails();


    this.dataToShow = [];
    this.defaultColor = true;
    this.graphState.sendGraphIsEditedData([{ hour: 0, power: 100 }]);
    this.graphState.getGraphRepresentation
      .pipe(takeUntil(this.unsubscribeGraphType))
      .subscribe((data) => {
        if (data != "") {
          this.graphRepresentationType = data;
        }
      });
    this.subscription = this.clo.getCloLiteHead.subscribe((data) => {
      if (data === "CloLite" || data === "Clolite") {
        this.showCloLite = false;
      }
    });
    this.graphState.getChangedGraphData.subscribe((data) => {
      //change rows when drag graph changes -start here
      if (this.registerForm.valid) {
        this.isNumericCreatedRows = true;
      }
      if (!this.showCloLite) {
        if (data.length) {
          this.dataToShow = [];
          data.forEach((content, index) => {
            this.dataToShow.push({
              hour: Math.round(content.hour),
              power: Math.round(content.power),
            });
          });
          this.f.cloHour.setValue(this.dataToShow[1].hour);
          this.f.initialOutput.setValue(this.dataToShow[0].power);
          this.updateCloLiteValues(true);
        }
      }
    }); //change rows when drag graph changes -ends here
    this.checkFinalDefaultTable();
    this.applyGraphDisabledState();
  }

  checkClearFields() {
    if (this.registerForm.controls["initialOutput"].value === "" && this.registerForm.controls["cloHour"].value === "") {
      this.disableNumericClear = true;
    } else {
      this.disableNumericClear = false;
    }
  };

  resetValues() {
    this.cloLIteDetail.requiredProperties.forEach(element => {
      if (element === "CloLiteEnabled" && this.cloLIteDetail.properties['CloLiteEnabled']['default'] != null) {
        this.enableChecked = this.cloLIteDetail.properties['CloLiteEnabled']['default'];
      } else if (element === "CloLiteInitialPowerLevel" && this.cloLIteDetail.properties['CloLiteInitialPowerLevel']['default'] != null) {
        this.f.initialOutput.setValue(this.cloLIteDetail.properties['CloLiteInitialPowerLevel']['default']);
      } else if (element === "CloLiteMaximumWorkingHours" && this.cloLIteDetail.properties['CloLiteMaximumWorkingHours']['default'] != null) {
        this.f.cloHour.setValue(this.cloLIteDetail.properties['CloLiteMaximumWorkingHours']['default']);
      }
    });
    this.afterClearField = false;
    this.updateCloLiteValues(false);
    this.disableGraph = !this.cloLIteDetail.properties['CloLiteEnabled']['default'];
    this.applyGraphDisabledState();
  };

  resetDefaultStatusCheck() {
    if (this.enableChecked == this.cloLIteDetail.properties['CloLiteEnabled']['default'] && this.registerForm.controls["initialOutput"].value == this.cloLIteDetail.properties['CloLiteInitialPowerLevel']['default'] && this.registerForm.controls["cloHour"].value == this.cloLIteDetail.properties['CloLiteMaximumWorkingHours']['default']) {
      this.featureDefaults.setCloLiteDefaultColor(true);
    } else {
      this.featureDefaults.setCloLiteDefaultColor(false);
    }
  }

  loadCloLIteDetails() {
    if (this.appState.getConfigurationData()) {
      const configureData = this.fileResponse;
      this.cloLIteDetail = this.cloLiteSchema;
      this.setRegisterFormValues();
      this.cloLIteDetail.requiredProperties.forEach(element => {
        if (element === "CloLiteEnabled" && this.cloLIteDetail.properties['CloLiteEnabled']['default'] != null) {
          this.enableChecked = configureData.resp && configureData.resp.CLOLite != null ? configureData.resp.CLOLite['CloLiteEnabled'] : this.cloLIteDetail.properties['CloLiteEnabled']['default'];
          this.disableGraph = !this.enableChecked;
        } else if (element === "CloLiteInitialPowerLevel" && this.cloLIteDetail.properties['CloLiteInitialPowerLevel']['default'] != null) {
          this.registerForm.controls["initialOutput"].setValue(configureData.resp && configureData.resp.CLOLite != null ? configureData.resp.CLOLite['CloLiteInitialPowerLevel'] : this.cloLIteDetail.properties['CloLiteInitialPowerLevel']['default']);
        } else if (element === "CloLiteMaximumWorkingHours" && this.cloLIteDetail.properties['CloLiteMaximumWorkingHours']['default'] != null) {
          this.registerForm.controls["cloHour"].setValue(configureData.resp && configureData.resp.CLOLite != null ? configureData.resp.CLOLite['CloLiteMaximumWorkingHours'] : this.cloLIteDetail.properties['CloLiteMaximumWorkingHours']['default']);
        }
      });
      this.updateCloLiteValues(false);
    }
  };

  initForm() {
    this.registerForm = this.fb.group({
      cloHour: [
        "",
        [
          Validators.required,
          Validators.pattern("^[0-9]*$"),
        ],
      ],
      cloSteps: [
        "",
        [
          Validators.pattern("^[0-9]*$"),
        ],
      ],
      initialOutput: [
        "",
        [
          Validators.required,
          Validators.pattern("^[0-9]*$"),
        ],
      ],
      finalOutput: [
        "",
        [
          Validators.pattern("^[0-9]*$"),
        ],
      ],
    });
  }

  setRegisterFormValues() {
    this.registerForm.controls["initialOutput"].setValidators([
      Validators.required,
      Validators.pattern("^[0-9]*$"),
      Validators.min(this.cloLIteDetail.properties['CloLiteInitialPowerLevel']['minimum']),
      Validators.max(this.cloLIteDetail.properties['CloLiteInitialPowerLevel']['maximum']),
    ]);
    this.registerForm.controls["cloHour"].setValidators([
      Validators.required,
      Validators.pattern("^[0-9]*$"),
      Validators.min(this.cloLIteDetail.properties['CloLiteMaximumWorkingHours']['minimum']),
      Validators.max(this.cloLIteDetail.properties['CloLiteMaximumWorkingHours']['maximum']),
    ]);
    this.registerForm.controls["initialOutput"].updateValueAndValidity();
    this.registerForm.controls["cloHour"].updateValueAndValidity();
    this.disableNumericClear = false;
    this.submitted = true
  }

  updateCloLiteValues(flagGraph) {
    const cloLite = {
      CloLiteEnabled: this.enableChecked,
      CloLiteInitialPowerLevel: this.registerForm.controls["initialOutput"].errors ? this.cloLIteDetail.properties['CloLiteInitialPowerLevel']['default'] : Number(this.f.initialOutput.value),
      CloLiteMaximumWorkingHours: this.registerForm.controls["cloHour"].errors ? this.cloLIteDetail.properties['CloLiteMaximumWorkingHours']['default'] : Number(this.f.cloHour.value)
    };
    this.setConfigurationData(cloLite, 'CLOLite');
    this.misc.sendCloLitedata(cloLite);
    this.sendValuesToGraph(flagGraph);
    this.checkCloLiteCreatFileError();
  }

  sendValuesToGraph(flagGraph) {
    let data;
    if (this.registerForm.valid) {
      if(flagGraph){
        data = [{
          hour: 0,
          power: this.dataToShow[0].power
        },
        {
          hour: this.registerForm.controls["cloHour"].value,
          power: this.dataToShow[1].power
        }
        ];
      }
      else{
      data = [{
        hour: 0,
        power: this.registerForm.controls["initialOutput"].value
      },
      {
        hour: this.registerForm.controls["cloHour"].value,
        power: this.cloLIteDetail.properties['CloLiteInitialPowerLevel']['maximum']
      }
      ];
    }
      this.graphState.sendGraphData(
        this.graphRepresentationType,
        data
      );
    } else {
      if(!flagGraph){
        data = [{
          hour: 0,
          power: this.registerForm.controls["initialOutput"].value
        },
        {
          hour: this.registerForm.controls["cloHour"].value,
          power: this.cloLIteDetail.properties['CloLiteInitialPowerLevel']['maximum']
        }
        ];
        this.graphState.sendGraphData(
          this.graphRepresentationType,
          data
        );
      }

    }

    this.graphState.setCloLiteEnableGraph(this.enableChecked);
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }

  inputValueChanged($event) {
    this.afterClearField = false;
    this.setRegisterFormValues();
    this.updateCloLiteValues(false);
    this.checkClearFields();
    this.resetDefaultStatusCheck();
    this.checkCloLiteCreatFileError();
    this.fewFieldValuePresent = false;
    if ($event.key !== "Tab") {
      this.submitted = true;
    }
    if ($event.key === "Backspace" || $event.key === "Delete") {
      this.submitted = true;
      if (this.fewFieldValuePresent === false) {
        this.graphState.sendGraphValidData("valid");
      }
    }
  }

  setConfigurationData(value, keyVal) {
    // Use centralized method to save feature data
    // This automatically saves to both ConfigurationData and SaveSetData
    const cloLiteObj = Object.assign({}, value);
    this.appState.setFeatureData(keyVal, cloLiteObj);
    this.resetDefaultStatusCheck();
  }

  checkCloLiteCreatFileError() {
    if (this.registerForm.controls["initialOutput"].errors || this.registerForm.controls["cloHour"].errors) {
      this.cloLiteCreatFile = true;
    } else {
      this.cloLiteCreatFile = false;
    }
    this.misc.setCLOliteInputError.next(this.cloLiteCreatFile);
  }

  checkFinalDefaultTable() {
    if (this.enableChecked === true) {
      this.defaultColor = false;
    }
  }


  tabChanged($event: NgbNavChangeEvent) {
    if ($event.nextId === "1") {
      this.isNumericCreatedRows = false;
    }
  }

  get f() {
    return this.registerForm.controls;
  }

    private applyGraphDisabledState(): void {
    if (!this.registerForm) {
       return;
     }
    const action = this.disableGraph ? 'disable' : 'enable';
    this.registerForm[action]({ emitEvent: false });
    this.addForm[action]({ emitEvent: false });
  }
  enableGraph(value) {
    this.enableChecked = value;
    this.updateCloLiteValues(false);
    this.resetDefaultStatusCheck();
    this.checkClearFields();
    this.disableGraph = !value;
    this.defaultColor = !value;
    if (this.enableChecked) {
      this.defaultColor = false;
    }
    this.applyGraphDisabledState();
    this.graphState.setCloLiteEnableGraph(value);
  }




  @HostListener("document:click", ["$event"])
  public documentClick(event: Event): void {
    this.menuState = false;
  }
  @HostListener("document:contextmenu", ["$event"])
  public documentRClick(event: Event): void {
    this.menuState = false;
  }


  clearNumericFields() {
    this.disableNumericClear = true;
    for (const key of Object.keys(this.f)) {
      this.f[key].setValue("");
    };
    this.registerForm.controls["initialOutput"].setErrors({ require: true });
    this.registerForm.controls["cloHour"].setErrors({ require: true });
    this.submitted = true;
    this.updateCloLiteValues(false);
    this.checkClearFields();
    this.checkCloLiteCreatFileError();
    this.unsubscribe.next(undefined);
    this.isNumericCreatedRows = false;
    this.dataToShow = [];
    this.dataToShow.push({ hour: 0, power: 100 });
    this.graphState.sendGraphIsEditedData([{ hour: 0, power: 100 }]);
    this.graphState.sendGraphData(
      this.graphRepresentationType,
      this.dataToShow
    );
    this.tableValueSubmit = false;
    this.isTableValuesChanged = false;
  }
  ngOnDestroy() {
    this.unsubscribeGraphType.next(undefined);
    this.unsubscribeNumeric.next(undefined);
    this.unsubscribe.next(undefined);
  }

  onSubmit() {

  }
}

